import { DeleteDialog, ErpDataTableV2 } from '@/components/custom/erp';
import { getDataTableColumns } from './cols-definition';
import { BoPhan, BoPhanInput } from '@/types/schemas';
import { ActionBar, FormDialog } from './components';
import { useCRUD, useForms } from '@/hooks';
import { QUERY_KEYS } from '@/constants';
import { useSearchTable } from './hooks';

const PAGE_SIZE = 20;

export default function DanhMucBoPhanKeToan() {
  const {
    data: departments,
    totalItems,
    currentPage,
    detail,
    fetchDetail,
    handlePageChange,
    addItem: addDepartment,
    updateItem: updateDepartment,
    deleteItem: deleteDepartment,
    refreshData: refreshDepartments,
    searchData
  } = useCRUD<BoPhan, BoPhanInput>({
    endpoint: QUERY_KEYS.BO_PHAN,
    pageSize: PAGE_SIZE
  });

  const {
    showForm,
    showDelete,
    formMode,
    selectedObj,
    selectedRowIndex,
    isCopyMode,

    handleCloseForm,
    handleCloseDelete,
    handleAddClick,
    handleEditClick,
    handleViewClick,
    handleDeleteClick,
    handleCopyClick,
    handleRowClick,
    clearSelection
  } = useForms<BoPhan>(fetchDetail);

  const { searchState, handleSearchChange, onPageChange, hasFilterParams } = useSearchTable({
    searchData,
    isFiltered: false,
    handlePageChange: handlePageChange
  });

  const displayData = hasFilterParams ? searchState.searchResults : departments || [];
  const resolvedCurrentPage = hasFilterParams ? searchState.currentPage : currentPage;
  const resolvedTotalItems = hasFilterParams ? searchState.totalCount : totalItems;

  const tables = [
    {
      name: '',
      rows: displayData,
      columns: getDataTableColumns()
    }
  ];

  const handleSubmit = async (data: BoPhanInput) => {
    try {
      if (formMode === 'add') {
        await addDepartment({ ...data, action: 'NEW' });
      } else if (formMode === 'edit' && selectedObj) {
        await updateDepartment(selectedObj.uuid, { ...data, action: 'EDIT' });
      }
      refreshDepartments();
      handleCloseForm();
      clearSelection();
    } catch (error) {
      return;
    }
  };

  return (
    <div className='flex h-full min-h-[calc(100vh-120px)] w-full flex-col'>
      <div className={'block'}>
        <ActionBar
          onAddIconClick={handleAddClick}
          onEditIconClick={() => selectedObj && handleEditClick()}
          onDeleteIconClick={() => selectedObj && handleDeleteClick()}
          onCopyIconClick={() => selectedObj && handleCopyClick()}
          onWatchIconClick={() => selectedObj && handleViewClick()}
          onRefreshClick={refreshDepartments}
          isEditDisabled={!selectedObj}
          isViewDisabled={!selectedObj}
          isDeleteDisabled={!selectedObj}
          isCopyDisabled={!selectedObj}
        />

        <ErpDataTableV2
          tables={tables}
          onRowClick={handleRowClick}
          selectedRowId={selectedRowIndex || undefined}
          totalItems={resolvedTotalItems}
          currentPage={resolvedCurrentPage}
          onPageChange={onPageChange}
          serverSidePagination={true}
          pageSize={PAGE_SIZE}
          onSearchChange={handleSearchChange}
        />
      </div>

      {showForm && (
        <FormDialog
          open={showForm}
          formMode={formMode}
          initialData={formMode === 'add' && !isCopyMode ? undefined : detail}
          onClose={handleCloseForm}
          onSubmit={handleSubmit}
          onAdd={() => {
            handleCloseForm();
            clearSelection();
            setTimeout(() => {
              handleAddClick();
            }, 100);
          }}
          onEdit={() => {
            if (selectedObj) {
              handleCloseForm();
              handleEditClick();
            }
          }}
          onDelete={() => {
            if (selectedObj) {
              handleCloseForm();
              handleDeleteClick();
            }
          }}
          onCopy={() => {
            if (selectedObj) {
              handleCloseForm();
              handleCopyClick();
            }
          }}
        />
      )}

      {showDelete && (
        <DeleteDialog
          open={showDelete}
          onClose={handleCloseDelete}
          selectedObj={selectedObj}
          deleteObj={deleteDepartment}
          clearSelection={clearSelection}
        />
      )}
    </div>
  );
}
